export const ADVISOR_TYPE = {
  REGULAR: 'R',
  REGULAR_TRANSIT: 'RT',
  MSV: 'V'
};
